import { AffiliateLink } from '@components/common/AffiliateLink';
import { SidebarWrapper } from '@components/common/SidebarWrapper/SidebarWrapper';
import { Newsletter } from '@components/layout/Footer/Newsletter/Newsletter';
import { MEDIA_QUERIES, useMediaQuery } from '@student-coin/coinpaper-components';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { ArticleLatestNews } from '../ArticleLatestNews/ArticleLatestNews';
import { ArticleTags } from '../ArticleTags/ArticleTags';
import { ArticleTopReads } from '../ArticleTopReads/ArticleTopReads';
import { AuthorNote } from '../AuthorNote';
import { RelatedArticles } from '../RelatedArticles';
import { ShareArticle } from '../ShareArticle';
import { AffiliateLinksWrapper, Container, NewsletterContainer } from './ArticleFooter.styles';
import { ArticleFooterProps } from './ArticleFooter.types';

export const ArticleFooter = React.forwardRef<HTMLDivElement, ArticleFooterProps>(
  (
    { author, url, relatedArticles, textToShare, tags, affiliateLinks, topReads, latestNews },
    forwardedRef,
  ) => {
    const isLaptopWide = useMediaQuery(MEDIA_QUERIES.laptopL);
    const { t } = useTranslation('articles');

    return (
      <Container ref={forwardedRef}>
        {!isLaptopWide && affiliateLinks?.length > 0 && (
          <>
            <ArticleLatestNews heading={t('latest-news')} articles={latestNews} />
            <ArticleTopReads heading={t('top-read')} articles={topReads} />
          </>
        )}
        <NewsletterContainer>
          <Newsletter headingKey="newsletter:shortHeading" />
        </NewsletterContainer>
        {author && (
          <AuthorNote
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            picture={author?.avatar?.formats?.thumbnail?.hash}
            name={author?.name}
            slug={author?.slug}
            bio={author?.bio}
            id={author?.id}
          />
        )}
        <ShareArticle
          {...{
            articleLink: url,
            onClickLink: () => null,
            onClickFacebook: () => null,
            onClickTwitter: () => null,
            onClickInstagram: () => null,
            onClickLinkedIn: () => null,
            onClickTelegram: () => null,
          }}
          text={textToShare}
        />
        {tags?.length > 0 && <ArticleTags tags={tags} />}
        {!isLaptopWide && affiliateLinks?.length > 0 && (
          <AffiliateLinksWrapper>
            <SidebarWrapper heading="Affiliate links" titleWithLine={false}>
              {affiliateLinks?.map((link) => (
                <AffiliateLink
                  key={link.url}
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  image={link.logo.hash}
                  href={link.url}
                  text={link.text}
                  title={link.name}
                />
              ))}
            </SidebarWrapper>
          </AffiliateLinksWrapper>
        )}
        {relatedArticles?.length > 0 && (
          <RelatedArticles
            border="solid"
            header={{ text: 'RELATED ARTICLES', variant: 'medium' }}
            items={relatedArticles}
            desktopCardView={{ thumbnail: 'top', variant: 'medium' }}
            mobileCardView={{ thumbnail: 'left', variant: 'small' }}
            grid={{ column: 2 }}
            oneLineAuthor
          />
        )}
      </Container>
    );
  },
);

ArticleFooter.displayName = 'ArticleFooter';
